import { Box, LinearProgress, Typography } from "@mui/material";

interface MilestoneProgressBarProps {
  value: number;
}

export function MilestoneProgressBar({ value }: MilestoneProgressBarProps) {
  const normalizedValue = Math.max(0, Math.min(100, value));

  return (
    <Box sx={{ mt: 1 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
        <Typography variant="caption" color="text.secondary">
          Progress
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {normalizedValue}%
        </Typography>
      </Box>
      <LinearProgress variant="determinate" value={normalizedValue} />
    </Box>
  );
}
